module.exports = __webpack_public_path__ + "img/mission-statement-mobile.63a29535.svg";